export const filterTypes = {
  numeric: [
    {
      value: ">",
      label: "Больше"
    },
    {
      value: "=",
      label: "Равно"
    },
    {
      value: "<",
      label: "Меньше"
    },
    {
      value: "!=",
      label: "Не равно"
    },
    {
      value: "!null",
      label: "Исключить пустые поля"
    },
    {
      value: "between",
      label: "Между"
    },
    {
      value: "in",
      label: "Вхождение"
    }
  ],
  string: [
    {
      value: "=",
      label: "Равно"
    },
    {
      value: "!=",
      label: "Не равно"
    },
    {
      value: "!null",
      label: "Исключить пустые поля"
    },
    {
      value: "like",
      label: "Содержит"
    },
    {
      value: "in",
      label: "Содержит следующие"
    }
  ],
  boolean: [
    {
      value: "=",
      label: "Равно"
    },
    {
      value: "!=",
      label: "Не равно"
    }
  ]
};
